import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getCurrentUser, setCurrentUser } from 'store/storeValtio.js';
import { updateUserInDb } from 'store/localDb';
import { parseForm } from 'helpers/generalHelpers.js';

export default function ProfileForm() {
  const currentUser = getCurrentUser();
  //console.log('ProfileForm', currentUser);

  const [submitError, setSubmitError] = useState();
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  function exit(e) {
    e.preventDefault();
    console.log('ProfileForm back');
    navigate(-1);
  }

  async function handleSubmit(e) {
    e.preventDefault()
    setSubmitting(true);
    const formItems = e.target;
    //console.log('formItems', formItems);
    var formVals = parseForm(formItems);
    //console.log('formVals', formVals);

    var updatedProfile = {...currentUser};
    
    delete updatedProfile.description;
    //updatedProfile.userId = currentUser.userId,
    //updatedProfile.registrationDate = currentUser.registrationDate,
    //updatedProfile.registrationId = currentUser.registrationId
    updatedProfile.displayName = formVals.displayName;
    updatedProfile.firstName = formVals.firstName;
    updatedProfile.lastName = formVals.lastName;
    updatedProfile.email = formVals.email;
    updatedProfile.awakeTime = formVals.awakeTime;
    updatedProfile.bedTime = formVals.bedTime;

    //console.log('handleSubmit', currentUser, updatedProfile);
    try {
      await updateUserInDb(updatedProfile);
      setCurrentUser( updatedProfile );
    } catch (error) {
      console.log(error.message);
      setSubmitError(error.message);
    } finally {
      setSubmitting(false);
      navigate('/');
    }
  }

  function handleBlur(e) {
  }

  return (
    <div className='float-start w-full'>
    <div className='min-h-screen bg-gray-100 flex flex-col py-12 px-6 tablet:px-8'>
      <div className='mx-auto w-full max-w-md mb-4'>
        <h2 className='mt-6 text-center text-3xl font-extrabold text-gray-900'>
          Edit profile for account
          <br/>
          <span className='text-indigo-600'>{currentUser.displayName}</span>
        </h2>
      </div>

      {submitError && (
        <div
          className='bg-red-100 rounded-lg py-5 px-6 mb-3 text-base text-red-700'
          role='alert'
        >
          {submitError}
        </div>
      )}

      <div className='mt-4 mx-auto w-full max-w-md'>
        <div className='bg-white py-8 shadow rounded-lg px-10'>
          <form className='mb-0 space-y-6' onSubmit={handleSubmit}>
            <div>
              <label htmlFor='displayName' className='block text-sm font-medium text-gray-700' > Display name </label>
              <div className='mt-1'>
                <input 
                  onBlur={handleBlur} 
                  defaultValue={currentUser.displayName} 
                  id='displayName' 
                  name='displayName' 
                  type='text' 
                  autoComplete='name' 
                  required className='formText' 
                  /> 
              </div>
            </div>
            <div>
                <label htmlFor='firstName' className='block text-sm font-medium text-gray-700' > First name </label>
                <div className='mt-1'>
                  <input 
                    onBlur={handleBlur} 
                    defaultValue={currentUser.firstName} 
                    id='dispfirstNamelayName' 
                    name='firstName' 
                    type='text' 
                    autoComplete='name' 
                    required className='formText' 
                    /> 
                </div>
              </div>
              <div>
                <label htmlFor='lastName' className='block text-sm font-medium text-gray-700' > Last name </label>
                <div className='mt-1'>
                  <input 
                  onBlur={handleBlur} 
                  defaultValue={currentUser.lastName} 
                  id='lastName' 
                  name='lastName' 
                  type='text' 
                  autoComplete='name' 
                  required className='formText' 
                  /> 
                </div>
              </div>
            <div>
              <label htmlFor='email' className='block text-sm font-medium text-gray-700' > Email address </label> 
              <div className='mt-1'>
                <input 
                  onBlur={handleBlur} 
                  defaultValue={currentUser.email} 
                  id='email' 
                  name='email' 
                  type='email' 
                  autoComplete='email' 
                  required className='formText' 
                  /> 
              </div>
            </div>
            <div className='mt-1 flex justify-between'>
              <div className='w-[45%]'>
                <label htmlFor='awakeTime' className='block text-sm font-medium text-gray-700' >Awake Time</label>
                <div className='mt-1'>
                  <input 
                    onBlur={handleBlur} 
                    defaultValue={currentUser.awakeTime}
                    id='awakeTime' 
                    name='awakeTime' 
                    type='text' 
                    autoComplete='text' 
                    required className='formText' 
                    /> 
                </div>
              </div>
              <div className='w-[45%] float-right'>
                <label htmlFor='bedTime' className='block text-sm font-medium text-gray-700' >Bed Time</label>
                <div className='mt-1'>
                  <input 
                    onBlur={handleBlur} 
                    defaultValue={currentUser.bedTime} 
                    id='bedTime' 
                    name='bedTime' 
                    type='text' 
                    autoComplete='text' 
                    required className='formText' 
                    /> 
                </div>
              </div>
            </div>
            <div className='flex justify-between'>
              <button type='submit' disabled={submitting} className='okBtn'>Update</button> 
              <button onClick={exit} type='button' className='cancelBtn'>Cancel</button> 
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
);
}
